import React from 'react';

function PlayIcon(props) {
  return (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={38}
    height={38}
    fill="none"
    {...props}
  >
    <path fill="#fff" d="M38 0v38H0V0z" />
    <path fill="#474747" d="M31.01 18.5 12.268 29.34 12.25 7.69 31.01 18.5Z" />
  </svg>
  );
}

export default PlayIcon;